import "./productStyle.css";
import ProductPic from "../../../img/smaPicCart.png";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/smallProductLike.svg";
import iconSrcCard from "../../../svg/smallProductCard.svg";
import { useState, useEffect } from "react";
import addToCart from "../../../function/addToCard";
import { Link } from "react-router-dom";
import transliterate from "../../../function/transliterate";
import { PhotoProvider, PhotoSlider, PhotoView } from "react-photo-view";
import { findAuthorByName } from "../../mainPage/getAuthorLink";
import { getProductHref } from "../../../function/productLink";
export default function SmallProductCartTop({
  el,
  setCartCounterC,
  setLikeCounterC,
}) {
  const [liked, setLiked] = useState(false);
  const [authorLinkData, setAuthorLinkData] = useState(null);
  const [picWriterLinkData, setPicWriterLinkData] = useState(null);
  useEffect(() => {
    const fetchPicWriter = async () => {
      const result = await findAuthorByName(el?.picWriter);
      setPicWriterLinkData(result);
    };
    if (el?.picWriter) {
      fetchPicWriter();
    }
  }, [el?.picWriter]);

  useEffect(() => {
    const fetchAuthor = async () => {
      const result = await findAuthorByName(el?.textAutor);
      setAuthorLinkData(result);
    };
    if (el?.textAutor) {
      fetchAuthor();
    }
  }, [el?.textAutor]);
  useEffect(() => {
    if (!el?.uid) return;

    const likedProducts =
      JSON.parse(localStorage.getItem("likedProducts")) || [];

    const isLiked = likedProducts.some((product) => product.uid === el.uid);

    setLiked(isLiked);
  }, [el?.uid]);
  const handleLike = () => {
    // Отримуємо дані з localStorag
    let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];

    if (!liked) {
      // Додаємо товар до масиву подобається
      setLikeCounterC((prev) => prev + 1);
      likedProducts.push(el);
    } else {
      // Видаляємо товар з масиву подобається
      setLikeCounterC((prev) => prev + 1);
      const updatedLikedProducts = likedProducts.filter(
        (product) => product.uid !== el.uid,
      );
      likedProducts = updatedLikedProducts;
    }

    // Зберігаємо оновлений масив у localStorage
    localStorage.setItem("likedProducts", JSON.stringify(likedProducts));

    // Змінюємо стан liked
    setLiked(!liked);
  };
  const addingToCart = (id) => {
    addToCart(id);

    setCartCounterC((prev) => prev + 1);
  };
  const hasFixedSale = el.priceSale && el.priceSale !== "";
  const hasSalePercent =
    el.saleDiscountPercent && Number(el.saleDiscountPercent) > 0;
  const hasAction =
    el.actionDiscountPercent && Number(el.actionDiscountPercent) > 0;

  const finalPrice = hasFixedSale
    ? Number(el.priceSale)
    : hasSalePercent
      ? Math.round(el.price - (el.price * el.saleDiscountPercent) / 100)
      : hasAction
        ? Math.round(el.price - (el.price * el.actionDiscountPercent) / 100)
        : Number(el.price);
  const productImages = Array.isArray(el?.imageList)
    ? el.imageList.filter(Boolean)
    : [];
  return (
    <div className="smallProductWrap">
      {/* <PhotoProvider>
        <PhotoView src={el.imageList[0]}>
          <img
            src={el.imageList[0]}
            alt={`${el.bookName}`}
            className="productBigPictureImg"
          />
        </PhotoView>
        {el.imageList.slice(1).map((item, index) => (
          <PhotoView key={index} src={item}>
            <span style={{ display: "none" }} />
          </PhotoView>
        ))}
      </PhotoProvider> */}
      <PhotoProvider key={el.uid || el.id || el.bookName}>
        {productImages.map((item, index) => (
          <PhotoView key={`${el.uid || el.id}-${item}-${index}`} src={item}>
            {index === 0 ? (
              <img
                src={item}
                alt={el.bookName}
                className="productBigPictureImg"
              />
            ) : (
              <span style={{ display: "none" }} />
            )}
          </PhotoView>
        ))}
      </PhotoProvider>
      <div className="prodPricLikeCart">
        {/* <p className="salePriceCartSale">{el.price}</p>
            <p className="fullPriceCartG">грн</p> */}
        {/* {hasFixedSale && (
          <div className="prdeProdPricingCart">
            <div className="prdeProdPricingRotateCart">
              <p className="fullPriceCartNewR">{el.priceSale}</p>
              <p className="salePriceCart">{el.price}</p>
              <p className="fullPriceCartG">грн</p>
            </div>
          </div>
        )}
        {!hasFixedSale && hasAction && (
          <div className="prdeProdPricingCart">
            <div className="prdeProdPricingRotateCart">
              <p className="fullPriceCartNewR">{el.price}</p>
              <p className="salePriceCart">{finalPrice}</p>
              <p className="fullPriceCartG">грн</p>
            </div>
          </div>
        )}
        {!hasFixedSale && !hasAction && (
          <div className="prdeProdPricingCartTop">
            <div className="prdeProdPricingRotateCart">
              <p className="salePriceCartSale">{finalPrice}</p>
              <p className="fullPriceCartG">грн</p>
            </div>
          </div>
        )} */}
        {hasFixedSale && (
          <div className="prdeProdPricingCart">
            <div className="prdeProdPricingRotateCart">
              <p className="fullPriceCartNewR">{el.priceSale}</p>
              <p className="salePriceCart">{el.price}</p>
              <p className="fullPriceCartG">грн</p>
            </div>
          </div>
        )}

        {!hasFixedSale && hasSalePercent && (
          <div className="prdeProdPricingCart">
            <div className="prdeProdPricingRotateCart">
              <p className="fullPriceCartNewR">{el.price}</p>

              <p className="salePriceCart">{finalPrice}</p>
              <p className="fullPriceCartG">грн</p>
            </div>
          </div>
        )}

        {!hasFixedSale && !hasSalePercent && hasAction && (
          <div className="prdeProdPricingCart">
            <div className="prdeProdPricingRotateCart">
              <p className="fullPriceCartNewR">{el.price}</p>
              <p className="salePriceCart">{finalPrice}</p>
              <p className="fullPriceCartG">грн</p>
            </div>
          </div>
        )}

        {!hasFixedSale && !hasSalePercent && !hasAction && (
          <div className="prdeProdPricingCartTop">
            <div className="prdeProdPricingRotateCart">
              <p className="salePriceCartSale">{finalPrice}</p>
              <p className="fullPriceCartG">грн</p>
            </div>
          </div>
        )}

        <div className="likeCardWrapSmall">
          <div
            className={`likeProductSmallSale${liked ? "Click" : ""}`}
            onClick={handleLike}
          >
            <HandySvg src={iconSrc} width="34" height="31" />
          </div>
          <div
            className="likeProductSmallSale"
            onClick={() => addingToCart(el.uid)}
          >
            <HandySvg src={iconSrcCard} width="28.33" height="28.33" />
          </div>
        </div>
      </div>
      <h2 className="smallProdName">
        <Link className="smallProdName" to={getProductHref(el)}>
          {el.bookName}
        </Link>
      </h2>

      <div className="autorInformCart">
        <div className="autorInformSectionCart">
          <p>Автор:&nbsp;</p>
          {authorLinkData ? (
            <Link
              className="autorInformSectionCartNdm"
              to={`/author/${authorLinkData.uid}`}
            >
              {el.textAutor}
            </Link>
          ) : (
            <h4>{el.textAutor}</h4>
          )}
        </div>
        <div className="autorInformSectionCart">
          <p>Художник:&nbsp;</p>
          {picWriterLinkData ? (
            <Link
              className="autorInformSectionCartNdm"
              to={`/author/${picWriterLinkData.uid}`}
            >
              {el.picWriter}
            </Link>
          ) : (
            <h4>{el.picWriter}</h4>
          )}
        </div>
      </div>
      <Link to={getProductHref(el)} className="descriptionBooksCart">
        {el.smallDesc}
      </Link>
    </div>
  );
}
